/*
 * File Created: Thursday, 8th June 2023 1:47:16 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Theme, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import React from 'react'

function ViewProductDescriptionSkeleton(): JSX.Element {
  const theme: Theme = useTheme();
  return (
    <Box
      sx={{
        width: { xs: "100%", md: "50%" },
        display: "flex",
        flexDirection: "column",
        gap: 2,
        // backgroundColor: "green",
        paddingInline: { xs: 0, md: theme.spacing(2)},
      }}
    >
      <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.6,
          }}
        >
          <Skeleton variant="rectangular" height="40px" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1.5,
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{
                width: "40%",
                height: "40px",
              }}
            />
          </Box>
            <Skeleton
              variant="rectangular"
              sx={{
                // width: "0%",
                height: "80px",
              }}
            />
          <Box
            sx={{
              display: "flex", 
              flexDirection: "row",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{
                width: "50px",
                height: "30px",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                width: "130px",
                height: "40px",
              }}
            />
          </Box>
          <Box>
            <Skeleton
              variant="rectangular"
              sx={{
                width: "198px",
                height: "40px",
              }}
            />
          </Box>
        </Box>
        <Divider orientation="horizontal" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{
                width: "50px",
                height: "30px",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                width: "150px",
                height: "30px",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{
                width: "50px",
                height: "30px",
              }}
            />
            {[1, 2, 3, 4, 5].map((data) => {
              return (
                <Skeleton
                  key={data}
                  variant="circular"
                  sx={{
                    width: "30px",
                    height: "30px"
                  }}
                />
              )
            })}
          </Box>
        </Box>
    </Box>
  )
}

export default ViewProductDescriptionSkeleton